export type AllowedRegion = "eu" | "us" | "fedramp";
const ALLOWED_REGIONS = ["eu", "us", "fedramp"];

const REGIONAL_LOCATION_TO_REGION: Record<string, AllowedRegion> = {
  EU: "eu",
  US: "us",
  "US-fedramp": "fedramp",
};

export const REGIONS_DISPLAY_NAMES: Record<AllowedRegion, string> = {
  eu: "EU",
  us: "US",
  fedramp: "US FedRAMP",
};

export const isFedRampRegion = () => {
  return process.env.REACT_APP_REGIONAL_LOCATION === "US-fedramp";
};

export const getRegion = (): AllowedRegion => {
  const regionalLocation = process.env.REACT_APP_REGIONAL_LOCATION;
  const allowedRegion = regionalLocation && REGIONAL_LOCATION_TO_REGION[regionalLocation];

  if (!allowedRegion) {
    const hostnameParts = window.location.hostname.split(".");
    const spaceliftIndex = hostnameParts.findIndex((part) => part === "spacelift");
    const appIndex = hostnameParts.findIndex((part) => part === "app");

    // region is between spacelift and app in the hostname
    if (spaceliftIndex - 1 > appIndex) {
      const region = hostnameParts[spaceliftIndex - 1]?.toLowerCase();
      if (region && ALLOWED_REGIONS.includes(region)) {
        return region as AllowedRegion;
      }
    }

    return REGIONAL_LOCATION_TO_REGION.EU;
  }

  return allowedRegion;
};

export const createAccountNameWithRegion = (accountName: string, region: AllowedRegion) => {
  return `${accountName}.${region}`;
};

export const getRegionPartOfDomain = (region: AllowedRegion) => {
  switch (region) {
    case "eu":
      return "";
    case "us":
      return "us";
    case "fedramp":
      return "fedramp";
  }
};

export const isAccountNameValid = (accountName: string) => {
  const accountNameParts = accountName.split(".").filter(Boolean);

  return (
    accountNameParts.length === 2 && ALLOWED_REGIONS.includes(accountNameParts[1].toLowerCase())
  );
};
